import { Platform } from 'react-native';

// NOTE: Outset `boxShadow` requires API 28+.
export const SHOULD_USE_LEGACY_ELEVATION = Platform.OS === 'android' && Platform.Version < 28;

/**
 * A simple elevation scale based on the one from material design
 * @link https://ethercreative.github.io/react-native-shadow-generator/
 */
export const ELEVATIONS = {
  '1': {
    boxShadow: [{ offsetX: 0, offsetY: 1, blurRadius: 1, color: 'rgba(0, 0, 0, 0.18)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 1 } : {}),
  },
  '2': {
    boxShadow: [{ offsetX: 0, offsetY: 1, blurRadius: 1.41, color: 'rgba(0, 0, 0, 0.2)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 2 } : {}),
  },
  '3': {
    boxShadow: [{ offsetX: 0, offsetY: 1, blurRadius: 2.22, color: 'rgba(0, 0, 0, 0.22)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 3 } : {}),
  },
  '4': {
    boxShadow: [{ offsetX: 0, offsetY: 2, blurRadius: 2.62, color: 'rgba(0, 0, 0, 0.23)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 4 } : {}),
  },
  '6': {
    boxShadow: [{ offsetX: 0, offsetY: 3, blurRadius: 4.65, color: 'rgba(0, 0, 0, 0.27)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 6 } : {}),
  },
  '8': {
    boxShadow: [{ offsetX: 0, offsetY: 4, blurRadius: 4.65, color: 'rgba(0, 0, 0, 0.3)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 8 } : {}),
  },
  '9': {
    boxShadow: [{ offsetX: 0, offsetY: 4, blurRadius: 5.46, color: 'rgba(0, 0, 0, 0.32)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 9 } : {}),
  },
  '12': {
    boxShadow: [{ offsetX: 0, offsetY: 6, blurRadius: 7.49, color: 'rgba(0, 0, 0, 0.37)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 12 } : {}),
  },
  '16': {
    boxShadow: [{ offsetX: 0, offsetY: 8, blurRadius: 10.32, color: 'rgba(0, 0, 0, 0.44)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 16 } : {}),
  },
  '24': {
    boxShadow: [{ offsetX: 0, offsetY: 12, blurRadius: 16, color: 'rgba(0, 0, 0, 0.58)' }],
    ...(SHOULD_USE_LEGACY_ELEVATION ? { elevation: 24 } : {}),
  },
};
